import React from 'react'
import { Button } from 'reactstrap'

export default ({ color, ...props }) => {
  let passColor = color || 'default'

  return <Button color={passColor} {...props} />
}
